import { addDefaultIfEmpty, insertAfterIndex, removeAtIndex, sum, updateAtIndex } from "../../helpers/array"
import { uniqueId } from "../../helpers/uniqueId"

export type Subcontractor = {
  id: string
  description: string
  annualCost: number
}

export const emptySubcontractor = (): Subcontractor => ({id: uniqueId(), description: '', annualCost: 0})

export const createDefaultSubcontractors = (): Subcontractor[] => [
  emptySubcontractor(),
]

export const sumSubcontractors = (subcontractors: Subcontractor[]): number =>
  sum(subcontractors, x => x.annualCost)


export const updateAnnualCost = (subcontractors: Subcontractor[], index: number, annualCost: number): Subcontractor[] =>
  updateAtIndex(subcontractors, index, x => ({ ...x, annualCost }))

export const updateDescription = (subcontractors: Subcontractor[], index: number, description: string): Subcontractor[] =>
  updateAtIndex(subcontractors, index, x => ({ ...x, description }))

export const add = (subcontractors: Subcontractor[], index: number) =>
  insertAfterIndex(subcontractors, index, emptySubcontractor())

export const remove = (subcontractors: Subcontractor[], index: number) =>
  addDefaultIfEmpty(removeAtIndex(subcontractors, index), emptySubcontractor())

export const enforceInvariants = (subcontractors: Subcontractor[] | undefined): Subcontractor[] => {
  if (subcontractors && subcontractors.length > 0) {
    return subcontractors
  }
  
  return createDefaultSubcontractors()
} 